import { combineEpics } from 'redux-observable';

import { credentialsEpic } from '@bolteu/redux-session';

import { accountEpic } from 'rdx/account/epics';
import { analyticEpic } from 'rdx/analytics/epics';
import { applicationEpic } from 'rdx/application/epics';
import { AppServices } from 'rdx/middleware';
import { passwordEpic } from 'rdx/password';
import { promotionsPermissionsEpic } from 'rdx/promotions/epics';
import { sessionEpic } from 'rdx/session/epics';
import { GlobalAppState } from 'rdx/state';
import { supportEpic } from 'rdx/support';
import { targetingParametersEpic } from 'rdx/targetingParameters/epics';

// redux-session epics are typed with their own action union
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rootEpic = combineEpics<any, any, GlobalAppState, AppServices>(
  accountEpic,
  credentialsEpic,
  passwordEpic,
  supportEpic,
  sessionEpic,
  targetingParametersEpic,
  analyticEpic,
  applicationEpic,
  promotionsPermissionsEpic,
);
